import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b01ri6tu6x: FaireBrandEntity = {
  token: "b_b01ri6tu6x",
  type: "brand",
  name: "Kisiwa",
  avatarUrl:
    "https://cdn.faire.com/fastly/dd92032ad712357958dfb7a72ba48816346c4e3fdbc02a09db838ab8ca38ca1e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/36b26cbb80ed32dccfe99c8cfa8708820576a95fcc4dcfcc83222a4497540eb4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dd92032ad712357958dfb7a72ba48816346c4e3fdbc02a09db838ab8ca38ca1e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/36b26cbb80ed32dccfe99c8cfa8708820576a95fcc4dcfcc83222a4497540eb4.jpeg",
  location: "Kealakekua, HI, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 4,
  isInsider: false,
  description:
    "Kisiwa is a small jewelry line designed by Gadea Pérez-Andújar in her home studio in Kealakekua, Hawaii. Inspired by her travels and a love for clean minimalism and ancient jewelry, Kisiwa seeks to enhance the wearer's own individuality. Each piece is produced by hand, with an emphasis on craftsmanship and is therefore unique.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:32.756Z",
    importedBy: "entity-db-cli",
  },
};
